<template>
    <div class="pagination">
        <van-pagination v-model="currentPage" :total-items="total" :items-per-page="pageSize" @change="pageChange">
            <template #prev-text>
                <van-icon name="arrow-left" />
            </template>
            <template #next-text>
                <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
        </van-pagination>
    </div>
</template>
<script>
    export default {
        props: {
            total: {
                type: Number,
                default: 0
            },
            pageSize: {
                type: Number,
                default: 5
            },
            pageNo: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                currentPage: 1
            }
        },
        watch: {
            pageNo(value) {
                this.currentPage = value
            }
        },
        methods: {
            pageChange() {
                this.$emit('pageChange', this.currentPage)
            }
        }
    }
</script>
<style lang="scss" scoped>
.pagination {
    padding: 20px 0;
}
</style>